import * as React from 'react'
import { times } from 'lodash';
import { tableLoading } from 'src/modules/Alert/ControlCenter/utils/placeholders';
import DataTable from 'react-data-table-component';
import LogsTableSubHeader from './LogsTableSubHeader';

const columns = (isLoading: boolean, logsType: 'login' | 'audit') => 
logsType === 'login' ? 
  [
  { name: 'Date', sortable: true, ...tableLoading('date', isLoading, 90) },
  { name: 'User', sortable: true, ...tableLoading('email', isLoading, 90) },
  ] 
:[
  { name: 'Date', sortable: true, ...tableLoading('date', isLoading, 90) },
  { name: 'User', sortable: true, ...tableLoading('user', isLoading, 90) },
  { name: 'Table', sortable: true, ...tableLoading('table', isLoading, 90) },
  { name: 'Action', sortable: true, ...tableLoading('action', isLoading, 90) },
  { name: 'Entity ID', ...tableLoading('entityID', isLoading, 90) },
];

const loadingArray = times(10, Object);

function LogsTable(props): React.ReactElement {
  const { 
    logs,
    logsType,
    isLoading,
    dateRange,
    onSearched,
    total,
    onDateChanged,
    onFocusChanged,
    onSorted,
    onSizeChanged,
    onPageChanged 
  } = props;
  return (
    <DataTable
        className="data-table__container"
        columns={columns(isLoading, logsType)}
        data={isLoading ? loadingArray : logs}
        noHeader={true}
        fixedHeader={true}
        subHeader={true}
        subHeaderComponent={
          <LogsTableSubHeader 
            dateRange={dateRange}
            onSearched={onSearched}
            onDateChanged={onDateChanged}
            onFocusChanged={onFocusChanged}
          />
        }
        highlightOnHover={true}
        sortServer={true}
        onSort={onSorted}
        pagination={true}
        paginationServer={true}
        paginationTotalRows={total}
        onChangeRowsPerPage={onSizeChanged}
        onChangePage={onPageChanged}
      />
  )
}

export default LogsTable
